import { Card, FlexBox, Typography, FluidImage } from '@vp/swan';
import React from 'react';
import './src-components-AdvanceMessagingComponent-OrderList-OrderCard.styles.scss.js';
import { formatDateWithOrdinal } from './src-utils-miaw-common.js';

const OrderCard = ({
  orderDate,
  orderId,
  orderItems,
  //  orderNumber,
  displayPrice,
  onClick,
  sender
}) => {
  const getFormattedItems = () => {
    let updatedList = [];
    if (orderItems.length > 2) {
      updatedList = orderItems.slice(0, 1);
      updatedList.push({
        type: "reactNode",
        element: /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-standard-bold", className: "order-items-more" }, `+${orderItems.length - 1}`)
      });
    } else {
      updatedList = orderItems;
    }
    return updatedList;
  };
  const handleOrderClick = () => {
    if (sender === "chatbot" && onClick) {
      onClick(orderId);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Card,
    {
      onClick: handleOrderClick,
      bordered: true,
      padding: 6,
      compactMode: true,
      className: "order-card",
      skin: sender === "chatbot" ? "link" : void 0,
      marginY: "between-actions",
      style: { cursor: sender === "chatbot" ? "pointer" : "default" }
    },
    /* @__PURE__ */ React.createElement(FlexBox, { justifyContent: "space-between" }, /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "column", gap: "2" }, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-small-bold" }, `Order N.: ${orderId}`), /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-small" }, `Ordered on: ${formatDateWithOrdinal(new Date(orderDate))}`), /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-small-bold" }, `Total paid: ${displayPrice}`)), /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "row", gap: "between-icon-and-text" }, getFormattedItems().map((item) => {
      if (item.type === "reactNode") {
        return item.element;
      }
      return /* @__PURE__ */ React.createElement(FluidImage, { key: item.itemId, src: item.imageUrl, alt: "", style: { width: "48px", height: "48px", borderRadius: "4px" } });
    })))
  ));
};

export { OrderCard as default };
//# sourceMappingURL=src-components-AdvanceMessagingComponent-OrderList-OrderCard.js.map
